<template>
<div class="tab-pane active" id="step6">
	<h2 class="hidden-lg">{{ $t("tab.summary") }}</h2>
	<div class="row">
		<div class="register-area">
			<div class="col-md-12">
				<div class="box-for overflow">
					<div class="col-md-12 col-xs-12 register-blocks">
						<div class="col-md-12">
							<h2>{{ $t("tab.summary") }}</h2>
						</div>
						<div v-show="basket.exhibitionHall != null && basket.exhibitionHall != ''"
							class="col-md-2">
							<b>{{ $t('labels.exhibition_hall') }}:</b>
						</div>
						<div v-show="basket.exhibitionHall != null && basket.exhibitionHall != ''"
							class="col-md-10">
							{{ basket.exhibitionHall }}
						</div>
						<div class="col-md-2" v-show="basket.exhibitionBoothNumber != null && basket.exhibitionBoothNumber != ''">
							<b>{{ $t('labels.exhibition_booth_number') }}:</b>
						</div>
						<div class="col-md-10" v-show="basket.exhibitionBoothNumber != null && basket.exhibitionBoothNumber != ''">
							{{ basket.exhibitionBoothNumber }}
						</div>
						<!-- booth -->
						<div class="col-md-12">
							<h5 v-if="basket.selectedBooth != null">{{ $t("summary.package") }}</h5>
						</div>
						<table class="table summery-table" v-if="basket.selectedBooth != null">
							<thead>
								<tr>
									<th class="hidden-xs"></th>
									<th>{{ $t("basket.item") }}</th>
									<th class="text-right">{{ $t("basket.price_in") }}</th>
								</tr>
							</thead>

							<tbody>
								<tr>
									<td rowspan="3" class="hidden-xs"><img :src="basket.selectedBooth.previewImage" height="50px" v-if="basket.selectedBooth.previewImage != null"></td>
									<td>
										{{ $t("basket.booth_package") }} (<span>{{ basket.selectedBooth.displayName }}</span>)<br><br>
										<span class="text-break">{{ basket.selectedBooth.displayDescription }}</span><br><br>
										<span v-if="basket.carpetColor != null">{{ $t("basket.carpetColor") }}:
											<span class="color-span" :style="'background-color: ' + basket.carpetColor.hex"></span>
										</span>
									</td>
									<td class="text-right">{{ $filters.formatMoney(costs.boothCost) }}</td>
								</tr>
								<tr>
									<td colspan="2" class="hidden-xs">
										<button type="button" class="btn border-btn border-btn-sm more-black" @click.prevent="removeBooth">{{ $t('buttons.remove') }}</button>
									</td>
								</tr>
								<tr v-show="basket.label != '' && basket.selectedBooth != null">
									<td class="hidden-xs">{{ $t("basket.booth_label") }}: {{ basket.label }}</td>
									<td class="text-right">{{ $filters.formatMoney(costs.labelCost) }}</td>
								</tr>
							</tbody>
						</table>
						<!-- articles -->
						<div class="col-md-12">
							<h5 v-if="hasArticles">{{ $t("summary.articles") }}</h5>
						</div>
						<table v-if="hasArticles" class="table summery-table article-table">
							<thead>
								<tr>
									<th class="hidden-xs"></th>
									<th>{{ $t("basket.item") }}</th>
									<th class="text-right">{{ (!netValuesOnly) ? $t("basket.netPrice") : $t("basket.price_in") }}</th>
									<th v-if="!netValuesOnly" class="text-right">{{ $t("basket.vatPrice") }}</th>
									<th v-if="!netValuesOnly" class="text-right">{{ $t("basket.price_in") }}</th>
								</tr>
							</thead>

							<tbody v-for="article in shoppingCart.items"
								:key="article.id"
								v-bind:value="article"
								v-show="article.count > 0">
								<tr>
									<td rowspan="2" class="hidden-xs"><img :src="'/images/articles/' + article.images[0].path" height="50px" v-if="article.images != null && article.images.length > 0 && article.images[0].path != null"></td>
									<td>
										<div v-if="article.unit === 'sqm'"> {{ article.displayName }} {{ getDisplayCount(article) }}m²</div>
										<div v-if="article.unit === 'pc'">{{ getDisplayCount(article) }}x {{ article.displayName }}</div>
										<small v-show="article.inclusive > 0">({{ article.inclusive }} {{ (article.inclusive_unit == 'pc') ? $t('labels.per_unit') : '/&#13217;' }} incl.)</small>
										<small v-show="article.print_inclusive === 1">(incl.)</small>
										<br>
										{{ $filters.formatMoney(article.exhibitionPrices.price_net) }} / {{ (article.unit == 'pc') ? $t('labels.per_unit') : '&#13217;' }}
									</td>
									<td class="text-right">{{ $filters.formatMoney(article.totalNet) }}</td>
									<td v-if="!netValuesOnly" class="text-right">{{ $filters.formatMoney(article.totalVat) }}</td>
									<td v-if="!netValuesOnly" class="text-right">{{ $filters.formatMoney(article.total) }}</td>
								</tr>

								<tr>
									<td :colspan="(!netValuesOnly) ? 4 : 2">
										<div class="input-group input-group-sm col-xs-4 col-sm-2">
											<span class="input-group-btn">
												<button
													class="btn btn-primary btn-sm"
													tabindex="-1"
													type="button"
													@click="removeFromBasket(article)"
													:disabled="article.count <= article.inclusive">
													<i class="fa fa-minus" aria-hidden="true"></i>
												</button>
											</span>
											<input
												class="form-control"
												type="number"
												:step="(article.unit === 'pc') ? 1 : 0.01"
												:min="article.inclusive"
												:value="article.count"
												name="depth"
												@blur="updateCount(article, $event.target)">
											<span class="input-group-btn">
												<button
													class="btn btn-primary btn-sm"
													tabindex="-1"
													type="button"
													@click="addToBasket(article)">
													<i class="fa fa-plus" aria-hidden="true"></i>
												</button>
											</span>
										</div>
									</td>
								</tr>
							</tbody>
							<template v-for="printItem in printItems" :key="printItem.id">
								<summary-article
									:article="printItem"
									:is-print="true"
									:net-values-only="netValuesOnly"
									@add="addToBasket"
									@updateCount="updateCount"
									@remove="removeFromBasket">
								</summary-article>
							</template>
						</table>

						<div class="col-md-12" v-if="costs.additionalCosts.length > 0">
							<h5>{{ $t("summary.other_costs") }} <small>({{ $t("summary.other_costs_notice") }})</small></h5>
						</div>

						<table v-if="costs.additionalCosts.length > 0 || costs.exhibitionRentCost > 0" class="table summery-table">
							<thead>
								<tr>
									<th class="hidden-xs"></th>
									<th>{{ $t("basket.item") }}</th>
									<th class="text-right">{{ $t("basket.price_in") }}</th>
								</tr>
							</thead>

							<tbody>
								<tr v-for="cost,index in costs.additionalCosts"
									:key="index" v-bind:value="cost">
									<td class="hidden-xs"></td>
									<td>{{ cost.displayName }}:</td>
									<td class="text-right">{{ $filters.formatMoney(cost.amount) }}</td>
								</tr>
								<tr v-show="costs.exhibitionRentCost > 0">
									<td v-if="basket.boothType" class="hidden-xs">
										<div class="booth active" :class="basket.boothType.css_class"></div>
									</td>
									<td>
										{{ $t("basket.rent") }}<br>
										<div v-if="(basket.width > 0 && basket.depth > 0) || basket.boothType != null"
											class="row">
											<span class="col-xs-12" v-if="basket.boothType != null"><b>{{ $t("basket.booth_type") }}: </b>{{  $t(basket.boothType.translation_key) }}</span>
											<span class="col-xs-12" v-if="basket.width > 0 && basket.depth > 0"><b>{{ $t("basket.size") }}: </b>{{ $filters.formatLength(basket.width) }} x {{ $filters.formatMoney(basket.depth) }} m ({{ $filters.formatLength(costs.squareMeter) }} {{ $t("labels.sqm") }})</span>
										</div>
									</td>
									<td class="text-right">{{ $filters.formatMoney(costs.exhibitionRentCost) }}</td>
								</tr>
							</tbody>
						</table>

						<table class="table summery-table">
							<thead>
								<tr>
									<th class="hidden-xs"></th>
									<th>{{ $t("basket.item") }}</th>
									<th class="text-right">{{ $t("basket.price_in") }}</th>
								</tr>
							</thead>

							<tbody>
							</tbody>

							<tfoot>
								<tr v-if="activePriceLevel">
									<td class="hidden-xs"></td>
									<td>{{ (inEnglish) ? activePriceLevel.name_en : activePriceLevel.name }} ({{ activePriceLevel.percentage }}%):</td>
									<td class="text-right">{{ $filters.formatMoney(costs.priceLevelCost) }}</td>
								</tr>

								<tr>
									<th class="hidden-xs"></th>
									<th>{{ $t("basket.total") }}:</th>
									<th class="text-right">{{ $filters.formatMoney(basket.total) }}</th>
								</tr>

								<tr v-if="!netValuesOnly">
									<th class="hidden-xs"></th>
									<th>{{ $t("basket.total_gross_summary") }}:</th>
									<th class="text-right">{{ $filters.formatMoney(basket.total_gross) }}</th>
								</tr>
							</tfoot>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row" v-if="!isExhibitionClosed">
		<div class="col-md-12">
			<hr>
			<div class="wizard-footer">
				<div class="pull-right">
					<a href="#">
						<input
							type='button'
							class='btn btn-next btn-warning'
							name='next'
							:value='($t("tab.submit") + " " + $t("buttons.next_to"))'
							@click="store.updateCurrentTab('submit')" />
					</a>
				</div>
				<div class="pull-left">
					<input v-if="hasPrintableArticlesSelected"
						type='button'
						class='btn btn-previous btn-warning'
						name='previous'
						:value='($t("buttons.prev_to") + " " + $t("tab.prints"))'
						@click="store.updateCurrentTab('articles')" />
				</div>
				<div class="clearfix"></div>
			</div>
		</div>
	</div>
</div>
</template>

<script setup>
import { useMainStore } from '@/store'
import { computed, onMounted } from 'vue'
import { cloneDeep } from 'lodash'
import { ARTICLE_TYPE_PRINTABLE } from '@/constants'

const store = useMainStore()
// define passed props
const props = defineProps({
	exhibition: {
		type: Object,
		required: true,
	},
	basket: {
		type: Object,
		required: true,
	},
	netValuesOnly: {
		type: Boolean,
		default: false,
	},
	isExhibitionClosed: {
		type: Boolean,
		default: false,
	},
})
// define emits
const emit = defineEmits(['saveBasket', 'unselectBooth', 'resetDisplayedBooth'])
// define computed props
const inEnglish = computed(() => store.inEnglish)
const shoppingCart = computed(() => store.settings.shopping_cart)
const costs = computed(() => store.costs)
const activePriceLevel = computed(() => store.activePriceLevel)

const hasArticles = computed(() => {
	return shoppingCart.value.items.length > 0
		|| shoppingCart.value.print_items.length > 0
})

const printItems = computed(() => {
	const items = {}
	shoppingCart.value.print_items.forEach((item) => {
		if (!items.hasOwnProperty(item.id)) {
			items[item.id] = cloneDeep(item)
		} else {
			items[item.id].count += item.count
			items[item.id].count_after_inclusive += item.count_after_inclusive
			items[item.id].totalNet += item.totalNet
			items[item.id].totalVat += item.totalVat
			items[item.id].total += item.total
		}
	})

	return items
})

const hasPrintableArticlesSelected = computed(() => {
	let selected = false
	for (const article of shoppingCart.value.items) {
		if (article.type === ARTICLE_TYPE_PRINTABLE) {
			selected = true
			break
		}
	}

	return selected
})

// define methods
const addToBasket = (article) => {
	article.count = Math.round(article.count + 1)
	emit('saveBasket')
}

const removeFromBasket = (article) => {
	article.count = Math.round(article.count - 1)
	emit('saveBasket')
}

const updateCount = (article, target) => {
	if (target.value == null || target.value == "") {
		target.value = 0
	}
	article.count = (target.value > article.inclusive) ? target.value : article.inclusive
	target.value = article.count
	emit('saveBasket')
}

const removeBooth = () => {
	emit('unselectBooth')
	emit('resetDisplayedBooth', 'summary')
}

const getDisplayCount = (article) => {
	return article.count
}

onMounted(async () => {
	await store.fetchExhibitionInformation()
})
</script>
